module.exports = __webpack_public_path__ + "77afd8d3bdf851a9029bbe322dab7bd8.pdf";